import { render } from "./MenuItemForm.vue?vue&type=template&id=7d78bf7c"
import script from "./MenuItemForm.vue?vue&type=script&lang=js"
export * from "./MenuItemForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__